import axios from 'axios'
import Cookies from 'js-cookie' // Ensure you have js-cookie library installed
import { getCookieValue } from '../common-services'
import { BASE_URL } from './../../config'

export const insertClass = async (classNumber, className, classCode, courseName) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?schoolCode=${schoolCode}&loginId=${loginId}&insertClass=1&classNumber=${classNumber}&className=${className}&classCode=${classCode}&courseName=${courseName}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while adding class', err.message)
  }
}

export const updateClass = async (classNumber, className, classCode, courseCode, classId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    // api-controller/master-settings/getMasterSettingsData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&updateClass=1&classNumber=-2&className=nurSerin&classCode=NURSE&courseCode=SCHOOL&schoolId=1&classId=1
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?schoolCode=${schoolCode}&loginId=${loginId}&updateClass=1&classNumber=${classNumber}&className=${className}&classCode=${classCode}&courseCode=${courseCode}&schoolId=1&classId=${classId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while updating class', err.message)
  }
}

export const deleteClass = async (classId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?schoolCode=${schoolCode}&loginId=${loginId}&toggleClass=1&classId=${classId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const addClassSection = async (classId, stream, sectionName, maxRollNumber, roomNo) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&addSection=1&classId=1&stream=GENERAL&sectionName=A&maxRollNumber=50&schoolId=1&roomNo=1
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&addSection=1&classId=${classId}&stream=${stream}&sectionName=${sectionName}&maxRollNumber=${maxRollNumber}&schoolId=1&roomNo=${roomNo}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const updateClassSection = async (
  classId,
  stream,
  sectionName,
  maxRollNumber,
  roomNo,
  classSecId,
) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&updateSection=1&classId=1&stream=GENERAL&sectionName=C&maxRollNumber=50&roomNo=3&classSecId=28
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&updateSection=1&classId=${classId}&stream=${stream}&sectionName=${sectionName}&maxRollNumber=${maxRollNumber}&roomNo=${roomNo}&classSecId=${classSecId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const toggleClassSection = async (classSecId) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&deleteSection=1&classSecId=28
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&deleteSection=1&classSecId=${classSecId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const addSubject = async (subjectName, subjectLabel, subjectLongLabel) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&addSubject=1&subjectName=SOCIAL&subjectLabel=SOCIAL&subjectLongLabel=SOCIAL&subjectId=14
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&addSubject=1&subjectName=${subjectName}&subjectLabel=${subjectLabel}&subjectLongLabel=${subjectLongLabel}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const updateSubject = async (subjectName, subjectLabel, subjectLongLabel, subjectId) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&editSubject=1&subjectName=SOCIAL&subjectLabel=SOCIAL&subjectLongLabel=SOCIAL&subjectId=14
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&editSubject=1&subjectName=${subjectName}&subjectLabel=${subjectLabel}&subjectLongLabel=${subjectLongLabel}&subjectId=${subjectId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const deleteSubject = async (subjectId) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&deleteSubject=1&subjectId=14
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&deleteSubject=1&subjectId=${subjectId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const getAllsubjectListTable = async (classId) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&getsubjectlists=1&classId=1
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&getsubjectlists=1&classId=${classId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const addSubjectList = async (classId, stream, subjectName) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&addSubjectList=1&classId=1&stream=GENERAL&subjectNames[]=10
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&addSubjectList=1`,
      {
        classId,
        stream,
        // subjectNames: [subjectName],
        subjectName,
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const updateSubjectList = async (classId, stream, subjectNames, cslId) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&updateSubjectList=1&classId=1&stream=GENERAL&subjectNames[]=7&cslId=1
  try {
    console.log('class and stram', classId, stream)
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&updateSubjectList=1&classId=${classId}&stream=${stream}&cslId=${cslId}&subjectNames[]=${subjectNames}`,
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const deleteSubjectList = async (cslId) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&deleteSubjectList=1&cslId=61
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&deleteSubjectList=1&cslId=${cslId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const updatePassword = async (userId, userType, password) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&updatePassword=1&userId=1377&userType=STUDENT&password=123
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&updatePassword=1&userId=${userId}&userType=${userType}&password=${password}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const getAllIdentifier = async () => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&getAllIdentifier=1
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&getAllIdentifier=1`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const selectUniqueId = async () => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&selectUniqueId=1
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&selectUniqueID=1`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const selectIdentifier = async () => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&selectIdentifier=1
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&selectIdentifier=1`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const updateIdentifier = async (idType, identifierStr) => {
  // schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&updateIdConfiguration=1&idType=sid&identifierStr=%23sucodeyy#ssyearyy
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}&updateIdConfiguration=1&idType=${idType}&identifierStr=${encodeURIComponent(identifierStr)}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (err) {
    console.log('Error while deleting class', err.message)
  }
}

export const editSchoolConfiguration = async (
  // editSchoolConfiguration=1&schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&schoolCode=dem&schoolName=THE ABC PAATHSHALA&header1=A Play Cum Preparatory School&header2=948, Bari Cooperative Colony, Bokaro Steel City, Jharkhand,&zipCode=815312&schoolId=1&header3=CBSE Affiliation No -:3430623# 8051110555&header3=CBSE Affiliation No -:3430623&zipcode=815312&schoolId=1
  schoolCode,
  schoolName,
  logoImage,
  headerImage,
  header1,
  header2,
  header3,
  zipCode,
  schoolId,
  prevLogo = '',
  prevHeaderImage = '',
) => {
  try {
    const formData = new FormData()
    formData.append('editSchoolConfiguration', '1')
    formData.append('schoolCode', schoolCode)
    formData.append('schoolName', schoolName)
    formData.append('header1', header1)
    formData.append('header2', header2)
    formData.append('header3', header3)
    formData.append('zipCode', zipCode)
    formData.append('loginId', 'swipetouch')
    formData.append('schoolId', schoolId)

    if (prevLogo) formData.append('prevLogo', prevLogo)
    if (prevHeaderImage) formData.append('prevHeaderImage', prevHeaderImage)

    // Handle file uploads
    if (logoImage && logoImage instanceof File) {
      formData.append('logoImage', logoImage)
    }
    if (headerImage && headerImage instanceof File) {
      formData.append('headerImage', headerImage)
    }

    return await axios.post(`${BASE_URL}/api-controller/master-settings/getMasterSettingsData.php?`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.error('Error while updating school configuration:', err.message)
    return { status: 500, message: 'Failed to update school configuration' }
  }
}
